import React, { Component } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@mui/material';
import CustomCalendar from '../../components/calendar/CustomCalendar';
import { formatDate, parseDate } from '../../utils/formatCalendar';
import i18n from '../../i18n';

class DateTimePickerDialog extends Component {
    onClose = () => {};
    onSave = () => {};
    field = '';
    value = '';
    limit = 0;
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: props.dialogOpen || false,
            loading: false,
            startDate: parseDate(props.value).startDate || null,
            endDate: parseDate(props.value).endDate || null
        };
        this.onClose = props.onClose;
        this.onSave = props.onSave;
        this.field = props.field;
        this.limit = props.limit || 0;
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dialogOpen !== state.dialogOpen) {
            return {
                dialogOpen: props.dialogOpen,
                startDate: parseDate(props.value).startDate,
                endDate: parseDate(props.value).endDate,
                loading: false
            };
        }
        return null;
    }

    handleChange = (dateRange) => {
        this.setState({
            startDate: dateRange.startDate,
            endDate: dateRange.endDate
        });
    };

    handleSave = () => {
        const { startDate, endDate } = this.state;
        const previewDate = formatDate(startDate, endDate);
        this.onClose();
        this.onSave(previewDate);
    };
    handleClear = () => {
        this.setState({
            startDate: null,
            endDate: null
        });
        this.onSave('');
        this.onClose();
    };

    render() {
        return (
            <Dialog
                open={this.state.dialogOpen}
                onClose={this.onClose}
                maxWidth="md"
            >
                <DialogTitle>
                    {i18n.t('text.dateRange')}
                    {/* The limit was enforced but never stated: days past
                        it simply would not select. */}
                    {this.limit > 0 && (
                        <Typography
                            component="div"
                            variant="body2"
                            color="text.secondary"
                        >
                            {i18n.t('text.dateRangeMax', { count: this.limit })}
                        </Typography>
                    )}
                </DialogTitle>
                <DialogContent dividers>
                    <CustomCalendar
                        onChange={this.handleChange}
                        value={{
                            startDate: this.state.startDate,
                            endDate: this.state.endDate
                        }}
                        limit={this.limit}
                        shortcuts={[
                            {
                                label: 'today',
                                days: 1
                            },
                            {
                                label: 'thisWeek',
                                days: 'thisWeek'
                            },
                            {
                                label: 'thisMonth',
                                days: 'thisMonth',
                            }
                        ]}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose} color="inherit">
                        {i18n.t('buttons.cancel')}
                    </Button>
                    {this.props.value ? (
                        <Button onClick={this.handleClear} color="inherit">
                            {i18n.t('buttons.clearNClose')}
                        </Button>
                    ) : null}
                    <Button variant="contained" onClick={this.handleSave}>
                        {i18n.t('buttons.save')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default DateTimePickerDialog;
